import { ISubcontractor, ISubcontractorFilters } from 'src/app/modules/logged/subcontractors/store/types';

export class SetCurrentTab {
    static readonly type = '[subcontractor] set current tab';
    constructor(public tab?: 'GENERAL' | 'SITE MANAGERS' | 'INACTIVE' | 'CHANGE REQUESTS' | 'REMOVED' | 'EXPIRY REMINDER', public filters?: Partial<ISubcontractorFilters>) { }
}

export class SetSearchField {
    static readonly type = '[subcontractor] set search field';
    constructor(public value: string) { }
}

export class SetCompanyID {
    static readonly type = '[subcontractor] set company ID';
    constructor(public value: string) { }
}

export class SetFiltersBasedOnTab {
    static readonly type = '[subcontractor] set filters based on tab';
    constructor(public filters?: Partial<ISubcontractorFilters>) { }
}

export class VerifyHMRC {
    static readonly type = '[subcontractor] verify hmrc status';
    constructor(public subcontractorID: string) { }
}

export class VerifyVAT {
    static readonly type = '[subcontractor] verify vat status';
    constructor(public subcontractorID: string) { }
}

export class FetchChangeRequestsNumber {
    static readonly type = '[subcontractor] fetch change requests number';
    constructor() { }
}

export class ShowMore {
    static readonly type = '[subcontractor] show more';
    constructor(public siteManager: ISubcontractor) { }
}
